export default __webpack_public_path__ + "static/media/mask3.79bb1b48.jpg";